export const USER_API_ROUTES = {
  GET_SUBJECTS: '/users/customers/subject',
  GET_SUBJECT_BY_ID: '/users/customers/subject/:id',
};
